<template>
  <div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="mb-3">
          <label>
            Fecha inicio inscripciones
            <span class="text-danger">*</span>
          </label>
          <vee-field
            class="form-control"
            name="init_date_inscription"
            type="date"
            v-model="localData.init_date_inscription"
            :min="today"
            @change="handleChange"
          />
          <ErrorMessage class="text-danger" name="init_date_inscription" />
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="mb-3">
          <label>
            Fecha fin inscripciones
            <span class="text-danger">*</span>
          </label>
          <vee-field
            class="form-control"
            name="end_date_inscription"
            type="date"
            v-model="localData.end_date_inscription"
            :min="today"
            @change="handleChange"
          />
          <ErrorMessage class="text-danger" name="end_date_inscription" />
        </div>
      </div>

      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="mb-3">
          <label>Duración inscripciones</label>
          <input
            class="form-control"
            type="number"
            readonly
            :value="localData.duration_inscription"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="mb-3">
          <label>
            Fecha inicio evento
            <span class="text-danger">*</span>
          </label>
          <vee-field
            class="form-control"
            name="init_date"
            type="date"
            v-model="localData.init_date"
            :min="today"
            @change="handleChange"
          />
          <ErrorMessage class="text-danger" name="init_date" />
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-sm-12">
        <div class="mb-3">
          <label>
            Fecha fin evento
            <span class="text-danger">*</span>
          </label>
          <vee-field
            class="form-control"
            name="end_date"
            type="date"
            v-model="localData.end_date"
            :min="today"
            @change="handleChange"
          />
          <ErrorMessage class="text-danger" name="end_date" />
        </div>
      </div>

      <div class="col-lg-4 col-md-12 col-sm-12">
        <div class="mb-3">
          <label>Duración del evento</label>
          <input
            class="form-control"
            type="number"
            readonly
            :value="localData.duration"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      init_date_inscription: "",
      end_date_inscription: "",
      init_date: "",
      end_date: "",
      duration_inscription: 0,
      duration: 0,
    }),
  },
});

const emit = defineEmits(["update:modelValue", "validation-change"]);

const localData = ref({ ...props.modelValue });
const validationErrors = ref([]);

const today = computed(() => {
  const d = new Date();
  const month = (d.getMonth() + 1).toString().padStart(2, "0");
  const day = d.getDate().toString().padStart(2, "0");
  return `${d.getFullYear()}-${month}-${day}`;
});

const calculateDuration = () => {
  if (!localData.value.init_date || !localData.value.end_date) return;

  const start = new Date(localData.value.init_date);
  const end = new Date(localData.value.end_date);

  if (end < start) {
    localData.value.duration = 0;
    return;
  }

  const diffTime = end - start;
  localData.value.duration = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
};

const calculateDurationInscription = () => {
  if (
    !localData.value.init_date_inscription ||
    !localData.value.end_date_inscription
  )
    return;

  const start = new Date(localData.value.init_date_inscription);
  const end = new Date(localData.value.end_date_inscription);

  if (end < start) {
    localData.value.duration_inscription = 0;
    return;
  }

  const diffTime = end - start;
  localData.value.duration_inscription =
    Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;
};

const validateDates = () => {
  const errors = [];
  const nowDate = new Date(today.value);

  const startEvent = localData.value.init_date
    ? new Date(localData.value.init_date)
    : null;
  const endEvent = localData.value.end_date
    ? new Date(localData.value.end_date)
    : null;
  const startIns = localData.value.init_date_inscription
    ? new Date(localData.value.init_date_inscription)
    : null;
  const endIns = localData.value.end_date_inscription
    ? new Date(localData.value.end_date_inscription)
    : null;

  if (startEvent && startEvent < nowDate) {
    errors.push("La fecha de inicio del evento no puede ser anterior a hoy");
  }
  if (endEvent && endEvent < nowDate) {
    errors.push("La fecha de fin del evento no puede ser anterior a hoy");
  }
  if (startIns && startIns < nowDate) {
    errors.push(
      "La fecha de inicio de inscripciones no puede ser anterior a hoy"
    );
  }
  if (endIns && endIns < nowDate) {
    errors.push("La fecha de fin de inscripciones no puede ser anterior a hoy");
  }

  if (endEvent && startEvent && endEvent < startEvent) {
    errors.push(
      "La fecha de fin del evento no puede ser anterior a la fecha de inicio"
    );
  }

  if (endIns && startIns && endIns < startIns) {
    errors.push(
      "La fecha de fin de inscripciones no puede ser anterior a la fecha de inicio"
    );
  }

  if (startIns && startEvent && startIns > startEvent) {
    errors.push(
      "Las inscripciones no pueden iniciar después del inicio del evento"
    );
  }

  if (endIns && endEvent && endIns > endEvent) {
    errors.push(
      "Las inscripciones no pueden terminar después del fin del evento"
    );
  }

  validationErrors.value = errors;
  emit("validation-change", errors.length === 0);

  return errors.length === 0;
};

watch([() => localData.value.init_date, () => localData.value.end_date], () => {
  calculateDuration();
  validateDates();
  handleChange(); // Emite al padre
});

watch(
  [
    () => localData.value.init_date_inscription,
    () => localData.value.end_date_inscription,
  ],
  () => {
    calculateDurationInscription();
    validateDates();
    handleChange();
  }
);

watch(
  () => props.modelValue,
  (newVal) => {
    localData.value = { ...newVal };
    calculateDuration();
    calculateDurationInscription();
  },
  { deep: true }
);

const handleChange = () => {
  emit("update:modelValue", { ...localData.value });
};

const validate = () => {
  return validateDates();
};

defineExpose({ validate, validationErrors });
</script>
